// A customizable <select> (appearance: base-select) closes its own list on Escape,
// but the keydown still bubbles to the MUI Dialog/Popover around it, which would
// close too and drop unsaved input. Put this above the selects: it stops Escape
// only while a list is open, so the next Escape closes the parent as before.
export const keepEscapeInOpenSelect = (e) => {
    if (e.key !== 'Escape') return
    const select = e.target?.closest?.('select')
    let open = false
    try {
        open = Boolean(select?.matches(':open'))
    } catch (err) {
        // No `:open` support means no customizable select either.
    }
    if (open) e.stopPropagation()
}
